export const GENERATE_OFFRE_EMPLOI_REQUEST = "GENERATE_OFFRE_EMPLOI_REQUEST";
export const GENERATE_OFFRE_EMPLOI_SUCCESS = "GENERATE_OFFRE_EMPLOI_SUCCESS";
export const GENERATE_OFFRE_EMPLOI_FAIL = "GENERATE_OFFRE_EMPLOI_FAIL";
export const FETCH_OFFRE_EMPLOI_BY_DEMANDE_REQUEST = "FETCH_OFFRE_EMPLOI_BY_DEMANDE_REQUEST";
export const FETCH_OFFRE_EMPLOI_BY_DEMANDE_SUCCESS = "FETCH_OFFRE_EMPLOI_BY_DEMANDE_SUCCESS";
export const FETCH_OFFRE_EMPLOI_BY_DEMANDE_FAIL = "FETCH_OFFRE_EMPLOI_BY_DEMANDE_FAIL";
export const SAVE_OFFRE_EMPLOI_DRAFT_REQUEST = "SAVE_OFFRE_EMPLOI_DRAFT_REQUEST";
export const SAVE_OFFRE_EMPLOI_DRAFT_SUCCESS = "SAVE_OFFRE_EMPLOI_DRAFT_SUCCESS";
export const SAVE_OFFRE_EMPLOI_DRAFT_FAIL = "SAVE_OFFRE_EMPLOI_DRAFT_FAIL";
export const PUBLISH_OFFRE_EMPLOI_CAREERS_REQUEST = "PUBLISH_OFFRE_EMPLOI_CAREERS_REQUEST";
export const CLEAR_GENERATED_OFFRE_EMPLOI = "CLEAR_GENERATED_OFFRE_EMPLOI";

export const generateOffreEmploiRequest = (payload) => ({
    type: GENERATE_OFFRE_EMPLOI_REQUEST,
    payload,
});

export const generateOffreEmploiSuccess = (payload) => ({
    type: GENERATE_OFFRE_EMPLOI_SUCCESS,
    payload,
});

export const generateOffreEmploiFail = (payload) => ({
    type: GENERATE_OFFRE_EMPLOI_FAIL,
    payload,
});

export const fetchOffreEmploiByDemandeRequest = (demandeId) => ({
    type: FETCH_OFFRE_EMPLOI_BY_DEMANDE_REQUEST,
    payload: demandeId,
});

export const fetchOffreEmploiByDemandeSuccess = (payload) => ({
    type: FETCH_OFFRE_EMPLOI_BY_DEMANDE_SUCCESS,
    payload,
});

export const fetchOffreEmploiByDemandeFail = (payload) => ({
    type: FETCH_OFFRE_EMPLOI_BY_DEMANDE_FAIL,
    payload,
});

export const saveOffreEmploiDraftRequest = (id, payload) => ({
    type: SAVE_OFFRE_EMPLOI_DRAFT_REQUEST,
    payload: { id, payload },
});

export const saveOffreEmploiDraftSuccess = (payload) => ({
    type: SAVE_OFFRE_EMPLOI_DRAFT_SUCCESS,
    payload,
});

export const saveOffreEmploiDraftFail = (payload) => ({
    type: SAVE_OFFRE_EMPLOI_DRAFT_FAIL,
    payload,
});

export const publishOffreEmploiCareersRequest = (payload) => ({
    type: PUBLISH_OFFRE_EMPLOI_CAREERS_REQUEST,
    payload,
});

export const clearGeneratedOffreEmploi = () => ({
    type: CLEAR_GENERATED_OFFRE_EMPLOI,
});
